import { getQuery } from 'sutils';

const WEBOFFICE_MODE_KEY = '_o_mode';


const getWebofficeConfigV1 = () => {
    let webOfficeConfig = {};
    if (getQuery(WEBOFFICE_MODE_KEY) === 'simple') {
        webOfficeConfig = {
            titlebar: false,
            toolbar: false,
            custom: {
                mobile: {
                    hideTitlebar: true,
                    hideBottomToolbar: true,
                },
            },
        };
    } else {
        const { isShowTitleBar, isShowToolBar, isShowStatusBar, isShowMobileBottomBar } = window.__WO_config__ || {};
        webOfficeConfig = {
            ...(isShowTitleBar === false ? {
                titlebar: false,
            } : {}),
            ...(isShowToolBar === false ? {
                toolbar: false,
            } : {}),
            ...(isShowStatusBar === false ? {
                statusbar: {
                    statusBar: false,
                },
            } : {}),
            ...(isShowMobileBottomBar === false ? {
                custom: {
                    mobile: {
                        hideBottomToolbar: true,
                    },
                },
            } : {}),
        };
    }
    return webOfficeConfig;
};


const getWebofficeConfigV2 = () =>
    (window as any).AppConfig?.[window.clientVars?.privilegeAttribute?.can_edit ? 'normal' : 'reading'] || {};

export const updateWebofficeConfig = (appConfigInstance) => {
    // eslint-disable-next-line @tencent/tencent-docs-slide/slide-diff-check
    if (__IS_WEBOFFICE__) {
        appConfigInstance.bind(getWebofficeConfigV1());
        // 由于新版的 weboffice 配置是异步注入的，目前在这里延迟 100ms 再绑定 weboffice 配置
        // 可以确保 weboffice 场景下是最新的
        setTimeout(() => {
            appConfigInstance.bind(getWebofficeConfigV2());
        }, 100);
    }
};
